// import "core-js/stable";
// import "regenerator-runtime/runtime";
import * as Aida from "./common";
import * as cookies from "./cookies";
import productSearch from "./product-search";
import SmoothScroll from 'smooth-scroll';
import ScrollHint from 'scroll-hint';
import Swiper from 'swiper/bundle';

const initPage = () => {
	Aida.classCtrl();
	Aida.navbar();
	Aida.lazyLoad();
	Aida.fiAnime();
	Aida.modal();
	Aida.footerNav();
	// cookies.pathThrough();
	cookies.expandCookie();
	cookies.getAuthedCookie();
	Aida.currentUrl();
	Aida.coverwrap();
	Aida.moldedSize();
	Aida.acms();
	productSearch();
	new ScrollHint('.js-scroll-hint');
	SmoothScroll('a[href*="#"]', {
		speed: 500,
		speedAsDuration: true
	});

	//Press parts
	const moldedthumb = new Swiper(".molded_swiper_thumb", {
			slidesPerView: 'auto',
			watchOverflow: true,
			loop: false,
			spaceBetween: 10,
		}
	);
	const molded = new Swiper(".molded_swiper", {
		slidesPerView: 'auto',
		navigation: {
			nextEl: "._next",
			prevEl: "._prev",
		},
		thumbs: {
			swiper: moldedthumb,
		},
	});

	//Modals on products
	const swiper = new Swiper("#modal_swiper", {
		navigation: {
			nextEl: "._next",
			prevEl: "._prev",
		},
		// thumbs: {
		// 	swiper: swiperthumb,
		// },
	});
	Aida.modalSwiperCtrl(swiper)
	swiper.on('slideChange', function () {
		const thumbs = Array.prototype.slice.call(document.body.querySelectorAll(".modal_slide_thumb"));
		thumbs.forEach(thumb => {
			thumb.classList.remove("_active");
		})
		console.log(thumbs[swiper.activeIndex]);
		thumbs[swiper.activeIndex].classList.add("_active");
	});
	
	//top cover scrollable info
	const topMv = document.getElementsByClassName("aida_top_mv")[0];
	if (topMv !== undefined) {
		topMv.addEventListener("touchstart", function() {
			this.classList.add("_hidden");
		});
		topMv.addEventListener("click", function() {
			this.classList.add("_hidden");
		});
	}
}

//init
if (document.readyState !== "loading") {
	initPage();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		initPage();
	})
}
